import { Alert, Box, CircularProgress, Typography } from "@mui/material";
import { lazy, Suspense, useEffect, useState } from "react";
import { fetchDeposit } from "../services/zalohyService";
import { fetchCurrentCustomerDetails } from "../services/userService";
import { handleApiError } from "../utils/errorHandler";
import DepositInfoCard from "./DepositInfoCard";
import ModalWindow from "./modal/ModalWindow";
export default function SpravaZaloh({ isSmallUser = true }) {
  const VyseZalohyReadingForm = lazy(() => import("./VyseZalohyReadingForm"));

  // ─────────────────────────────────── stav
  const [depositHodnota, setDepositHodnota] = useState("");
  const [pendingDepositHodnota, setPendingDepositHodnota] = useState("");
  const [zpusobPlatby, setZpusobPlatby] = useState("");
  const [periodaZalohy, setPeriodaZalohy] = useState("");
  const [isLargeCustomer, setIsLargeCustomer] = useState(false);
  const [isMonthlyBilling, setIsMonthlyBilling] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [modalVisible, setModalVisible] = useState(false);

  // ─────────────────────────────────── načtení dat
  useEffect(() => {
    async function fetchData() {
      const result = await fetchDeposit();
      if (result.success) {
        setDepositHodnota(result.data.hodnotaZalohy);
        setPendingDepositHodnota(result.data.novaHodZalohy);
        setZpusobPlatby(result.data.zpusobPlatby);
        setPeriodaZalohy(result.data.periodaZalohy);
        setIsMonthlyBilling(result.data.periodaFakturace === "M");

        if (typeof result.data.jeVelkoodberatel === "boolean") {
          setIsLargeCustomer(result.data.jeVelkoodberatel);
        } else if (typeof result.data.sektor === "number") {
          setIsLargeCustomer(result.data.sektor === 1);
        } else {
          const customerResult = await fetchCurrentCustomerDetails();
          if (customerResult.success) {
            setIsLargeCustomer(customerResult.data?.sektor === 1);
          }
        }
      } else {
        setError(handleApiError(result));
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  // ─────────────────────────────────── obsluha UI
  const handleZmenaVyseZalohyBtnClick = () => {
    if (isLargeCustomer) {
      return;
    }
    if (isMonthlyBilling) {
      return;
    }
    setModalVisible(true);
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (error) {
    throw new Response(error.message, { status: error.status });
  }

  return (
    <Box
      sx={{
        mx: "auto",
        px: { xs: 1, sm: 2 },
        width: { xs: "90%", md: "90%", lg: "70%" },
      }}
    >
      <Typography variant="body2" sx={{ mb: 2 }}>
        Změna výše zálohy je možná pouze pro maloodběratele bez měsíční fakturace (min. 100 Kč).
      </Typography>

      <DepositInfoCard
        periodaZalohy={periodaZalohy}
        depositHodnota={depositHodnota}
        zpusobPlatby={zpusobPlatby}
        isSmallUser={isSmallUser && !isLargeCustomer && !isMonthlyBilling}
        onChangeDeposit={handleZmenaVyseZalohyBtnClick}
      />

      {/* modal pro zadání nové výše zálohy */}
      <ModalWindow visible={modalVisible} setVisible={setModalVisible}>
        <Suspense fallback={<CircularProgress />}>
          <VyseZalohyReadingForm
            monthlyDeposit={depositHodnota}
            setModalVisible={setModalVisible}
            setPendingDepositHodnota={setPendingDepositHodnota}
          />
        </Suspense>
      </ModalWindow>

      {pendingDepositHodnota > 0 && (
        <Alert severity="info" sx={{ mb: 2 }}>
          Změna výše zálohy z {depositHodnota} na {pendingDepositHodnota} je v
          procesu. Změna se uplatní od následujícího dne.
        </Alert>
      )}

    </Box>
  );
}
